import { getENV } from '@libs/common-next';

import { useProduct } from '@/entities/product';
import { usePurchaseFormValue } from '@/entities/purchase-form';
import { dataLayerPush, formatFulfillmentMethodOrder } from '@/shared/analytics';

export const useClickAutoshipSetupEvent = () => {
    const { product } = useProduct();

    const getValues = usePurchaseFormValue();

    const isCA = getENV('NEXT_PUBLIC_LOCALE') === 'en-CA';
    const currency = isCA ? 'CAD' : 'USD';

    function send() {
        if (!product) return;

        const quantity = getValues('quantity');
        const fulfilmentMethod = getValues('fulfilmentMethod');
        const purchaseOption = getValues('purchaseOption');

        const { sku, price: productPrice } = product;
        const price = productPrice.sale ?? productPrice.original;

        dataLayerPush({
            event: 'click_autoship_setup',
            value: price * quantity,
            currency,
            product_id: sku,
            product_price: price,
            product_quantity: quantity,
            fulfillment_method_order: formatFulfillmentMethodOrder(fulfilmentMethod, purchaseOption),
        });
    }

    return { send };
};
